import { BusinessProVisitorLoggedOut } from '@fiverr-private/header';

export default BusinessProVisitorLoggedOut;
